const CONSENT_KEY = 'flow-local-consent-v2';
const LEGACY_CONSENT_KEY = 'flow-local-cookie-consent';
const FIRST_TOUCH_KEY = 'flow-local-first-touch-v1';
const LATEST_TOUCH_KEY = 'flow-local-latest-touch-v1';
const GTM_ID = 'GTM-TPMCFVM6';
const META_PIXEL_ID = '3674064329567447';

const ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
  'li_fat_id'
];

let analyticsLoaded = false;

function readConsent() {
  const current = localStorage.getItem(CONSENT_KEY);
  if (current === 'accepted' || current === 'rejected') return current;

  const legacy = localStorage.getItem(LEGACY_CONSENT_KEY);
  if (legacy === 'accepted' || legacy === 'rejected') {
    localStorage.setItem(CONSENT_KEY, legacy);
    return legacy;
  }

  return null;
}

function currentTouch() {
  const params = new URLSearchParams(window.location.search);
  const touch = {
    landing_path: `${window.location.pathname}${window.location.search}`,
    captured_at: new Date().toISOString()
  };

  ATTRIBUTION_PARAMS.forEach((name) => {
    const value = params.get(name);
    if (value) touch[name] = value.slice(0, 250);
  });

  if (document.referrer) {
    try {
      const referrer = new URL(document.referrer);
      if (referrer.hostname !== window.location.hostname) {
        touch.referrer = referrer.hostname.slice(0, 250);
      }
    } catch {
      // Ignore malformed referrers supplied by the browser.
    }
  }

  return touch;
}

function persistAttribution() {
  const touch = currentTouch();
  const hasCampaignContext = ATTRIBUTION_PARAMS.some((name) => touch[name]) || touch.referrer;

  if (!localStorage.getItem(FIRST_TOUCH_KEY)) {
    localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(touch));
  }

  if (hasCampaignContext || !localStorage.getItem(LATEST_TOUCH_KEY)) {
    localStorage.setItem(LATEST_TOUCH_KEY, JSON.stringify(touch));
  }
}

function readStoredTouch(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
  } catch {
    return null;
  }
}

function campaignValuesForNavigation() {
  const current = new URLSearchParams(window.location.search);
  let campaignValues = ATTRIBUTION_PARAMS
    .map((name) => [name, current.get(name)])
    .filter(([, value]) => value);

  if (campaignValues.length === 0 && readConsent() === 'accepted') {
    const latest = readStoredTouch(LATEST_TOUCH_KEY) || readStoredTouch(FIRST_TOUCH_KEY) || {};
    campaignValues = ATTRIBUTION_PARAMS
      .map((name) => [name, latest[name]])
      .filter(([, value]) => value);
  }

  return campaignValues;
}

function decorateAttributionLinks() {
  const campaignValues = campaignValuesForNavigation();
  if (campaignValues.length === 0) return;

  document.querySelectorAll('a[href], iframe[src*="link.flow-local.com/widget/booking"], iframe[data-booking-src*="link.flow-local.com/widget/booking"]').forEach((element) => {
    try {
      const attribute = element.hasAttribute('data-booking-src') ? 'data-booking-src' : element.tagName === 'IFRAME' ? 'src' : 'href';
      const rawUrl = element.getAttribute(attribute);
      const url = new URL(rawUrl, window.location.href);
      const isBooking = url.hostname === 'link.flow-local.com' && url.pathname.includes('/widget/booking');
      const isInternalPage = url.origin === window.location.origin && element.tagName === 'A' && !rawUrl.startsWith('#');
      if (!isBooking && !isInternalPage) return;
      campaignValues.forEach(([name, value]) => url.searchParams.set(name, value));
      element.setAttribute(attribute, url.toString());
    } catch {
      // Leave an invalid or relative booking URL untouched.
    }
  });
}

function loadGoogleTagManager() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
    consent_state: 'accepted'
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}

function loadMetaPixel() {
  if (window.fbq) return;

  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
  (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

function loadAnalytics() {
  if (analyticsLoaded || readConsent() !== 'accepted') return;
  analyticsLoaded = true;
  persistAttribution();
  loadGoogleTagManager();
  loadMetaPixel();
  import('./vercel-insights.js');
}

function track(eventName, details = {}) {
  if (readConsent() !== 'accepted') return;

  const payload = {
    event: 'flow_local_event',
    event_name: eventName,
    page_path: window.location.pathname,
    ...details
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);

  if (window.fbq) {
    window.fbq('trackCustom', eventName, {
      page_path: payload.page_path,
      ...details
    });
  }
}

function classifyLink(link) {
  const href = link.getAttribute('href') || '';
  if (href.includes('link.flow-local.com/widget/booking')) return 'booking_started';
  if (href.startsWith('tel:')) return 'phone_clicked';
  if (href.startsWith('mailto:')) return 'email_clicked';
  if (href.includes('wa.me')) return 'whatsapp_clicked';
  if (href.includes('/voice-demo') || href === '#try-the-demo') return 'demo_opened';
  return null;
}

function bindConversionEvents() {
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-track-event]:not(section), a');
    if (!target) return;

    const eventName = target.dataset.trackEvent || classifyLink(target);
    if (!eventName) return;

    track(eventName, {
      link_text: (target.textContent || '').trim().slice(0, 120),
      link_url: (target.getAttribute('href') || '').slice(0, 300)
    });
  });
}

function bindViewEvents() {
  if (!('IntersectionObserver' in window)) return;

  const seen = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const eventName = entry.target.dataset.trackEvent || (entry.target.classList.contains('section-pricing') ? 'view_offer' : null);
      if (!eventName || seen.has(eventName)) return;
      seen.add(eventName);
      track(eventName, { section_id: entry.target.id || entry.target.dataset.section || '' });
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  document.querySelectorAll('section[data-track-event], section.section-pricing').forEach((section) => observer.observe(section));
}

function createConsentBanner() {
  let banner = document.getElementById('cookie-banner');

  if (!banner) {
    banner = document.createElement('div');
    banner.id = 'cookie-banner';
    banner.className = 'cookie-banner';
    banner.innerHTML = `
      <div class="cookie-content">
        <div class="cookie-text">
          <p class="cookie-title">Optional analytics</p>
          <p class="cookie-description">Allow Google and Meta measurement? Nothing optional loads before you agree. <a href="/privacy">Privacy details</a>.</p>
        </div>
        <div class="cookie-buttons">
          <button id="cookie-accept" class="cookie-btn cookie-btn-accept" type="button">Allow analytics</button>
          <button id="cookie-reject" class="cookie-btn cookie-btn-reject" type="button">Decline</button>
        </div>
      </div>`;
    document.body.appendChild(banner);
  }

  const title = banner.querySelector('.cookie-title');
  const description = banner.querySelector('.cookie-description');
  const accept = banner.querySelector('#cookie-accept');
  const reject = banner.querySelector('#cookie-reject');

  if (title) title.textContent = 'Optional analytics';
  if (description) {
    description.innerHTML = 'Allow Google and Meta measurement? Nothing optional loads before you agree. <a href="/privacy">Privacy details</a>.';
  }
  if (accept) accept.textContent = 'Allow analytics';

  banner.style.display = readConsent() ? 'none' : 'block';

  accept?.addEventListener('click', () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    banner.style.display = 'none';
    loadAnalytics();
    decorateAttributionLinks();
  });

  reject?.addEventListener('click', () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    localStorage.removeItem(FIRST_TOUCH_KEY);
    localStorage.removeItem(LATEST_TOUCH_KEY);
    banner.style.display = 'none';
    if (analyticsLoaded) window.location.reload();
  });

  document.getElementById('change-cookie-settings')?.addEventListener('click', () => {
    localStorage.removeItem(CONSENT_KEY);
    localStorage.removeItem(LEGACY_CONSENT_KEY);
    banner.style.display = 'block';
    banner.querySelector('button')?.focus();
  });
}

function init() {
  decorateAttributionLinks();
  createConsentBanner();
  bindConversionEvents();
  bindViewEvents();
  loadAnalytics();

  window.flowLocalTracking = {
    track,
    getConsent: readConsent,
    getAttribution: () => ({
      first: JSON.parse(localStorage.getItem(FIRST_TOUCH_KEY) || 'null'),
      latest: JSON.parse(localStorage.getItem(LATEST_TOUCH_KEY) || 'null')
    })
  };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
